import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { eventTypeSelector, useGetProfileQuery } from 'root-api'


export const useProfile = (profileFromProps) => {
  const eventType = useSelector(eventTypeSelector)
  const { params, path } = useRouteMatch()
  const {
    data: profileFromRequest,
    isLoading
  } = useGetProfileQuery(
    { slug: params.profileSlug },
    { skip: path !== '/:profileSlug' }
  )
  const profile = profileFromProps || profileFromRequest || eventType?.profile

  if (isLoading) return undefined
  if (!profile) return null
  return profile
}
